var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"mb-4",attrs:{"xl":"2","md":"4","sm":"6","xs":"12"}},[_c('div',{class:[_vm.classObj, _vm.color],style:({ paddingTop: '75%' })}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('color-view')],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02160cb3","hasScoped":true,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/theme/ColorTheme.vue
// module id = null
// module chunks = 